import React from "react";
import { NavLink, useHistory } from "react-router-dom";
import { getServiceNameWithNickname } from "../../../../utils/getServiceNameWithNickname";
import PageSpinner from "../../../elements/spinner/PageSpinner";
import { Alert } from "@material-ui/lab";
import { useTranslation } from "react-i18next";
import { TimestampToDateMoment } from "../../../../utils/timestampToDate";
import RenderStatus from "../../../styles/styledStatus";
import { CopyToClipboard } from "react-copy-to-clipboard/lib/Component";

import {
  StyledCol,
  StyledScrollTable,
  StyledTable,
  StyledTableBody,
  StyledTableHead,
  StyledTableRow
} from "../../../styles/styledTable";
import { StyledBreakWord } from "../../../styles/styledBreakWord";
import { StyledCopy } from "../../../styles/styledCopy";

const ExchangeHistoryList = ({ notification, setNotification, exchangeHistory }) => {
  const history = useHistory();

  const { t } = useTranslation("exchangerPage");

  if (!exchangeHistory) {
    return (
      <PageSpinner
        position="center"
        pt="20"
        pb="20"
      />
    );
  }

  if (exchangeHistory.length === 0) {
    return <Alert severity="warning">{t("history.table.emptyData")}</Alert>;
  }

  const showDetails = (e) => {
    if (e.target.closest(".stop-event")) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  return (
    <StyledScrollTable className="exchange-table_scroll">
      <StyledTable
        width="1920"
        size="14"
        className="exchange-table exchange-table_admin"
      >
        <StyledTableHead
          scroll="auto"
          col="8"
          className="exchange-table__head exchange-table_admin__head"
        >
          <div>
            Id
          </div>
          <div>
            {t("history.table.client")}
          </div>
          <div>
            {t("history.table.inService")}
          </div>
          <div>
            {t("history.table.inAmount")}
          </div>
          <div>
            {t("history.table.outService")}
          </div>
          <div>
            {t("history.table.outAmount")}
          </div>
          <div>
            {t("history.table.status")}
          </div>
          <div>
            {t("history.table.date")}
          </div>
        </StyledTableHead>
        <StyledTableBody>
          {exchangeHistory.map((item, key) => (
            <StyledTableRow
              key={key}
              scroll="auto"
              col="8"
              className="exchange-table__row exchange-table_admin__row"
              cursor="pointer"
              onClick={(e) => {showDetails(e);}}
              as={NavLink}
              to={`/exchange/${item.id}`}
            >
              <StyledCol
                inline
                data-title="id"
              >
                <CopyToClipboard
                  className="stop-event"
                  id="copy"
                  text={item.id}
                  onCopy={() => {
                    setNotification({
                      ...notification,
                      visible: true,
                      type: "success",
                      message: t("history.table.copied")
                    });
                  }}
                >
                  <StyledBreakWord as="p">
                    {item.id} <StyledCopy
                    title={t("history.table.copy")}
                    className="icon-light-copy"
                  />
                  </StyledBreakWord>
                </CopyToClipboard>
              </StyledCol>
              <StyledCol
                inline
                data-title={t("history.table.client")}
              >
                <StyledBreakWord>
                  {item.pair?.user?.nickname ? item.pair.user.nickname + ":" : ""} {item.pair?.user?.email}
                </StyledBreakWord>
              </StyledCol>
              <StyledCol
                data-title={t("history.table.inService")}
              >
                {item.pair?.exchangePair?.inService
                  ? getServiceNameWithNickname(item.pair.exchangePair.inService.name, item.pair.exchangePair.inService.nickname)
                  : "--"}
              </StyledCol>
              <StyledCol
                inline
                data-title={t("history.table.inAmount")}
              >
                <StyledBreakWord as="p">
                  {item.inAmount} {item.pair?.exchangePair?.inCurrency?.asset}
                </StyledBreakWord>
              </StyledCol>
              <StyledCol
                data-title={t("history.table.outService")}
              >
                {item.pair?.exchangePair?.outService
                  ? getServiceNameWithNickname(item.pair.exchangePair.outService.name, item.pair.exchangePair.outService.nickname)
                  : "--"}
              </StyledCol>
              <StyledCol
                inline
                data-title={t("history.table.outAmount")}
              >
                <StyledBreakWord as="p">
                  {item.outAmount} {item.pair?.exchangePair?.outCurrency?.asset}
                </StyledBreakWord>
              </StyledCol>
              <StyledCol
                inline
                data-title={t("history.table.status")}
              >
                {item?.status ? <RenderStatus status={item?.status?.value} /> : "--"}
              </StyledCol>
              <StyledCol
                data-title={t("history.table.date")}
              >
                {TimestampToDateMoment(item.createdAt)}
              </StyledCol>
            </StyledTableRow>
          ))}
        </StyledTableBody>
      </StyledTable>
    </StyledScrollTable>
  );
};

export default ExchangeHistoryList;